class LogServiceWrapper {
    constructor(logService, className) {
        this.className = className;
        this.logService = logService;
    }

    log(methodName, message, ...args) {
        this.logService.log(`${this.className}->${methodName}: ${message}`, ...args);
    }

    warn(methodName, message, ...args) {
        this.logService.warn(`${this.className}->${methodName}: ${message}`, ...args);
    }

    error(methodName, message, ...args) {
        this.logService.error(`${this.className}->${methodName}: ${message}`, ...args);
    }
}
